

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'match-bracket',
  props: {
    rowspan: {
      default: '2',
    },
    bracketwinner: { // 'top','bottom',none
      type: String,
      default: '',
    },
  },
});
